import { type ReactElement } from 'react';
import { Global, css } from '@emotion/react';
import { useTheme, BaseStyles } from '@doxyme/ui/theme';

export const GlobalStyles = (): ReactElement => {
  const theme = useTheme();

  return (
    <Global
      styles={css([
        BaseStyles,
        css`
          html {
            height: 100%;
            width: 100%;
            -webkit-text-size-adjust: 100%;
            font-family:
              ui-sans-serif,
              system-ui,
              -apple-system,
              BlinkMacSystemFont,
              Segoe UI,
              Roboto,
              Helvetica Neue,
              Arial,
              Noto Sans,
              sans-serif,
              Apple Color Emoji,
              Segoe UI Emoji,
              Segoe UI Symbol,
              Noto Color Emoji;
            line-height: 1.5;
            tab-size: 4;
            scroll-behavior: smooth;
          }
          body {
            margin: 0;
            height: inherit;
            width: inherit;
            background-color: ${theme.background.default.backend};
            color: ${theme.palette.text.body};
          }
          b,
          strong {
            font-weight: 600;
          }
          #__next {
            height: inherit;
            width: inherit;
          }
          .hide-injected-content {
            /*
              UserPilot is used to inject modals and slide-ins by the growth team,
              we don't want these to be visible in a call.
            */
            div[id*='userpilot'],
            #userpilotIframeContainer {
              /*
                !important is required as we are overriding an inline style set
                by UserPilot which we don't control
              */
              display: none !important;
            }
          }
          /* Hide Statuspage embed on in-call routes when useStatuspageIncidentEmbedSuppression sets this body class.
             We match by iframe src (not title) so this is not impacted by localization changes. */
          body.statuspage-suppression-in-call iframe[src*='status.doxy.me'],
          body.statuspage-suppression-in-call iframe[src*='statuspage.io'] {
            display: none !important;
          }
        `,
      ])}
    />
  );
};
